import { UserEvent } from '../../../constants';

export enum UserPrivateWebsocketEvent {
  Updated = UserEvent.UserUpdated,
  Message = UserEvent.MessageReceived,
}
